// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import Api from "./service/http";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBH_b7u0hJKhyTx7n7MrgSmiT_8tt1y7hA",
  authDomain: "allaboutoptions-1acca.firebaseapp.com",
  projectId: "allaboutoptions-1acca",
  storageBucket: "allaboutoptions-1acca.firebasestorage.app",
  messagingSenderId: "115181365241",
  appId: "1:115181365241:web:b2ed2c55d4e03ff37eff28",
  measurementId: "G-TZ5ZDPQXMG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const isIosDevice = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

const isStandalonePwa = () => {
  if (typeof window === "undefined") return false;
  return (
    window.navigator.standalone === true ||
    window.matchMedia?.("(display-mode: standalone)")?.matches === true
  );
};

const hasMessagingApis = () => {
  try {
    return (
      typeof window !== "undefined" &&
      "indexedDB" in window &&
      indexedDB !== null &&
      navigator.cookieEnabled &&
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window &&
      "fetch" in window &&
      ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") &&
      "PushSubscription" in window &&
      PushSubscription.prototype.hasOwnProperty("getKey")
    );
  } catch {
    return false;
  }
};

// Cloud Messaging needs Service Workers plus the Push and Notification APIs.
// iPhone/iPad Safari only expose those to Home Screen PWAs (iOS 16.4+).
// In a regular Safari tab, Firebase's getMessaging() still throws
// messaging/unsupported-browser as an *uncaught* error (it does the support
// check on a detached promise, so a try/catch around the call cannot stop it).
// Skip FCM entirely there so the rest of the app keeps working.
export const canUseFirebaseMessaging = async () => {
  if (isIosDevice() && !isStandalonePwa()) return false;
  if (!hasMessagingApis()) return false;
  try {
    return await isSupported();
  } catch {
    return false;
  }
};

let messagingPromise = null;
export const getMessagingIfSupported = () => {
  if (!messagingPromise) {
    messagingPromise = canUseFirebaseMessaging()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
};

// Request permission and get token for push notifications
export const requestNotificationPermission = async () => {
  try {
    const messaging = await getMessagingIfSupported();
    if (!messaging || typeof Notification === "undefined") {
      console.log('Push notifications are not supported in this browser.');
      return;
    }

    console.log('Requesting notification permission...');
    const permission = await Notification.requestPermission();
    console.log('Notification permission status:', permission);

    if (permission === 'granted') {
      // Get registration token
      const currentToken = await getToken(messaging, {
        vapidKey: 'BOG1N7Oec9H84wsuDZ7mRnNmoL_r7D8czAPqT_mY4HaUsWDIxVU2K0SsbSQyrVxkw0dCS49iXciuqlbFs8i_THQ' // Replace with your VAPID key from Firebase console
      });

      if (currentToken) {
        console.log('Send Token To Server:', currentToken);
        sendTokenToServer(currentToken);
        return currentToken;
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    } else {
      console.log('Notification permission denied.');
    }
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
  }
};

// Send token to server
const sendTokenToServer = async (token) => {
  try {
    await Api.post('store-notification-token', { token });
  } catch (error) {
    console.error('Error sending token to server:', error);
  }
};

export const onMessageListener = () => {
  return new Promise((resolve) => {
    getMessagingIfSupported().then((messaging) => {
      // Unsupported browsers never receive a foreground message, so the
      // promise simply stays pending - the same as when no message arrives.
      if (!messaging) return;
      onMessage(messaging, (payload) => {
        console.log('Message received in foreground:', payload);
        resolve(payload);
      });
    });
  });
};

export { app };
